import { useMutation } from '@apollo/client'
import { AddUserTagsDocument } from '../../../../../graphql/generated'
import useAlerts from '../../../hooks/useAlerts'

export default function useAddUserTags() {
  const { createAlert } = useAlerts()
  const [mutation, results] = useMutation(AddUserTagsDocument, {
    onError: () => {
      createAlert('There was a problem adding user tags')
    }
  })

  return { mutation, results }
}
